/**
 * Pure board-square sizing math for the gameplay stage.
 *
 * Extracted from GameScreen's applySquare so the sizing CONTRACT is unit-
 * testable without a browser: JSDOM cannot perform real CSS layout, so tests
 * exercise this formula directly with measured-rect inputs instead of
 * pretending to compute browser geometry.
 *
 * INVARIANT: the Phaser mount is always an exact square bounded by BOTH the
 * available width and the available height, so the board is fully visible —
 * never cropped, never taller than the visible area, never non-square.
 */

/**
 * Side of the largest fully-visible square for the stage.
 * Floored to whole CSS pixels (the mount is sized in integer px).
 * Negative/zero available height yields 0 (caller skips the write).
 */
export function stageSquareSide(availWidth: number, availHeight: number): number {
  return Math.floor(Math.min(availWidth, Math.max(0, availHeight)));
}

/**
 * Available height for the square.
 *  - non-stacked (side-by-side tiers): the stage is a bounded grid row —
 *    its measured height IS the bound.
 *  - stacked (phone): the stage row is auto-sized (its height would derive
 *    from the mount → circular), so the bound is the visible viewport height
 *    below the stage's top edge (visualViewport is URL-bar/dvh accurate).
 */
export function stageAvailableHeight(
  stacked: boolean,
  stageTop: number,
  stageHeight: number,
  viewportHeight: number,
): number {
  return stacked ? viewportHeight - stageTop : stageHeight;
}
